import { useContext } from "react"
import { LogInContext } from "./login.context"

export const useLogIn = () => {
    const context = useContext(LogInContext)
    if (context === undefined) {
        throw new Error(`Component is not inside LogInContext scope`);
    }
    return context
}